import React from 'react';
import PropTypes from 'prop-types';
import { forms as Forms } from '@breezeway/brzw-components';
import _ from 'lodash';

const TextareaFormik = ({ className, field, form, id, label, placeholder, required }) => {
  const { errors, submitCount, touched, setFieldValue } = form;
  const withError = (touched[field.name] || submitCount > 0) && !_.isEmpty(errors[field.name]);

  return (
    <Forms.Textarea
      className={className}
      id={id}
      isRequired={required}
      labelText={label}
      onChange={value => setFieldValue(field.name, value)}
      placeholderText={placeholder}
      value={field.value}
      withError={withError}
    />
  );
};

TextareaFormik.propTypes = {
  className: PropTypes.string,
  field: PropTypes.shape({}),
  form: PropTypes.shape({}),
  id: PropTypes.string,
  input: PropTypes.shape({}),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  placeholder: PropTypes.string,
  required: PropTypes.bool,
};

TextareaFormik.defaultProps = {
  className: '',
  required: false,
};

export default TextareaFormik;
